import { FLOW_BUILDER2_PAGE_NS } from '../../i18n';
import { Skeleton, Stack, Typography } from '@mui/material';
import { ChatHistoryHeader, ISwitcherButton, Switcher, useEditorStore } from '@diana/core';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { useFlowBuilder2PageContext } from '../../Context/useFlowBuilder2PageContext';
import { useFlowBuilder2PageStore } from '../../Store/useFlowBuilder2PageStore';
import { BuilderConfigureEditorTabEnum } from '../../Store/FlowBuilder2PageStore.types';

export const RightDrawerHeaderSwitcher = ({ isWorkflow = false }: { isWorkflow?: boolean }) => {
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);
  const { isLoading: isPageLoading } = useFlowBuilder2PageContext();

  const flowOriginId = useEditorStore((s) => s.flow?.properties?.originId ?? '');

  const activeTab = useFlowBuilder2PageStore((store) => store.rightDrawerActiveTab);
  const setActiveTab = useFlowBuilder2PageStore((store) => store.setRightDrawerActiveTab);

  const isAskDianaOpened = activeTab === BuilderConfigureEditorTabEnum.AskDiana;
  const showChatSessions = isAskDianaOpened || isWorkflow;

  const buttons: ISwitcherButton[] = useMemo(() => {
    return [
      { name: BuilderConfigureEditorTabEnum.AskDiana, text: t('labels.askDiana') },
      ...(!isWorkflow
        ? [{ name: BuilderConfigureEditorTabEnum.Configuration, text: t('labels.configuration') }]
        : []),
    ];
  }, [isWorkflow, t]);

  const onlyOneButton = buttons.length === 1;

  if (isPageLoading) return <Skeleton variant="rounded" width={220} height={36} />;

  return (
    <Stack width="100%" gap={0.25}>
      {onlyOneButton ? (
        <Stack justifyContent="center" height={36}>
          <Typography fontWeight={500} px={0.5}>
            {buttons[0].text}
          </Typography>
        </Stack>
      ) : (
        <Switcher
          buttons={buttons}
          value={isWorkflow ? BuilderConfigureEditorTabEnum.AskDiana : activeTab}
          setValue={setActiveTab}
          disabled={isWorkflow}
          sx={{ width: 'fit-content' }}
        />
      )}
      {showChatSessions && <ChatHistoryHeader flowOriginId={flowOriginId} />}
    </Stack>
  );
};
